/**
 * App.js - Composant principal de l'application HowMuch
 * 
 * Point d'entrée du routage React Router pour l'application de simulation budgétaire.
 * Configure toutes les routes disponibles dans l'application.
 * 
 * Architecture :
 * - BrowserRouter : Utilise l'API HTML5 History pour la navigation
 * - Routes disponibles :
 *   - "/" : Page d'accueil (landing page)
 *   - "/about" : Page à propos
 *   - "/simulate" : Simulateur simple avec email gate
 *   - "/simulate/premium" : Simulateur avancé avec scénarios
 */

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import Simulate from "./pages/simulateur";
import PremiumSimulateur from "./pages/simulateur-premium";
import Blog from "./pages/blog";
import BlogRule503020 from "./pages/blog-50-30-20";

/**
 * Composant App - Router principal
 * @returns {JSX.Element} Application avec routage configuré
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Page d'accueil - Landing page avec présentation du produit */}
        <Route path="/" element={<Home />} />
        
        {/* Page à propos - Informations sur HowMuch */}
        <Route path="/about" element={<About />} />
        
        {/* Simulateur simple - Calcul basique avec email gate */}
        <Route path="/simulate" element={<Simulate />} />
        
        {/* Simulateur premium - Version avancée avec 4 champs et scénarios */}
        <Route path="/simulate/premium" element={<PremiumSimulateur />} />

        {/* Blog - Articles SEO sur la finance personnelle */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/regle-50-30-20" element={<BlogRule503020 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
